import config from '../../config';

export default {
  url: `${config.api.baseURL}/accounts/:accountId/babies`,
  transformer(data) {
    return data;
  }
};
